module.exports = __webpack_public_path__ + "public/1.0.1_200686/img/DOF計算デュアルカメラモジュール.ba476193.png";